exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-preview {\r\n\r\n\r\n}\r\n\r\n.current-row3 {\r\n   /* min-height: 1012px;  */\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/avatars/avatars.component.css
// module id = ../../../../../src/app/components/avatars/avatars.component.css
// module chunks = main